import React from "react";
import { Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ChannelActions } from "@Store";
import { actions as DialogActions } from "@Store/Reducers/dialog";

type DeleteTextFieldDialogProps = {
    textFieldId: string;
    channelId?: string;
    onConfirmDelete?: () => void | Promise<void>;
};

const DeleteTextFieldContent: React.FC = () => {
    const { t } = useTranslation();
    return <>{t("home.tabs.textfield_delete_confirm")}</>;
};

const DeleteTextFieldActions: React.FC<DeleteTextFieldDialogProps> = ({
    textFieldId,
    channelId,
    onConfirmDelete,
}) => {
    const dispatch = useDispatch<any>();
    const { t } = useTranslation();

    const handleDelete = async () => {
        try {
            if (onConfirmDelete) {
                await onConfirmDelete();
            } else if (channelId) {
                await dispatch(
                    ChannelActions.deletePollTextField(textFieldId, channelId)
                );
            }
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(DialogActions.hideDialog());
        }
    };

    return (
        <Button
            onClick={handleDelete}
            variant="contained"
            size="small"
            color="secondary"
            type="submit"
        >
            {t("dialogs.delete")}
        </Button>
    );
};

export default {
    content: DeleteTextFieldContent,
    actions: DeleteTextFieldActions,
    title: "Delete Text Field",
};
